(function() {
  const btn = document.querySelector('.direct-checkout-btn');
  if (!btn) return;

  btn.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const variantId = this.dataset.variantId;
    const qtyInput = document.querySelector('input[name="quantity"]');
    const quantity = qtyInput ? qtyInput.value : 1;

    let checkoutUrl = '/checkout?updates[' + variantId + ']=' + quantity;

    const urlParams = new URLSearchParams(window.location.search);
    const discountCode = urlParams.get('discount') || urlParams.get('discount_code');

    if (discountCode) {
      checkoutUrl += '&discount=' + encodeURIComponent(discountCode);
    }

    window.location.href = checkoutUrl;
  });

  document.addEventListener('variant:change', function(event) {
    if (event.detail && event.detail.variant) {
      btn.dataset.variantId = event.detail.variant.id;
      btn.disabled = !event.detail.variant.available;
      btn.textContent = event.detail.variant.available ? 'Buy Now' : 'Sold Out';
    }
  });
})();
